export type TmdbImageVariant =
  | "w154"
  | "w185"
  | "w300"
  | "w342"
  | "w1000_and_h450_multi_faces"
  | "w1280"
  | "w1920_and_h800_multi_faces";

export const makeTmdbImageUrl = <T extends string | null | undefined = string>(
  variant: TmdbImageVariant,
  path: T,
): `https://imagetmdb.viewbox.fun/t/p/${TmdbImageVariant}${T}` | undefined => {
  if (!path) {
    return undefined;
  }

  return `https://imagetmdb.viewbox.fun/t/p/${variant}${path}`;
};
